import React, {useEffect, useState} from 'react';
import {Button, Row, Col, Typography, message, Table, Tooltip, Modal, Switch} from "antd";
import {collection, query, where, getDocs, addDoc, updateDoc, doc, deleteDoc} from "firebase/firestore";
import {firestore} from '../../services/firebase';
import {
  FileExcelOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  PlusCircleOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import Dialog from "./Dialog";
import Search from "antd/es/input/Search";
import {CSVLink} from "react-csv";

const Users = () => {

  //const db = app.firestore();
  const {Title} = Typography
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState({});
  const [open, setOpen] = useState(false);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  const {confirm} = Modal;

  useEffect(() => {
    let mounted = true;
    const getData = async () => {
      try {
        const _query = query(collection(firestore, 'usuarios'));
        const _snapshot = await getDocs(_query);
        setModels(_snapshot.docs.map(doc => ({...doc.data(), id: doc.id})));
      } catch (error) {
        console.log(error);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    getData();

    return () => {
      mounted = false
    }
  }, [open, model])


  const Save = async () => {

    if (model.nombre === undefined) {
      message.success('Porfavor ingrese un Nombre.')
      return;
    }

    if (model.apellidos === undefined) {
      message.success('Porfavor ingrese un Apellidos.')
      return;
    }

    if (model.correo === undefined) {
      message.success('Porfavor ingrese un CorreoElectrónico.')
      return;
    }

    if (model.telefono === undefined) {
      message.success('Porfavor ingrese un Télefono.')
      return;
    }

    let data = {
      nombre: model.nombre,
      apellidos: model.apellidos,
      correo: model.correo,
      telefono: model.telefono,
      pago: model.pago,
      empresa: model.empresa === undefined ? "" : model.empresa,
      ciudad: model.ciudad === undefined ? "" : model.ciudad,
      pais: model.pais === undefined ? "" : model.pais,
      ocupacion: model.ocupacion === undefined ? "" : model.ocupacion,
    }

    try {
      if (!model.id) {
        validar(model);
        const res = await addDoc(collection(firestore, 'usuarios'), data);
        !res ? message.success('Cambios guardados.') : message.error('Error al guardar.');
      } else {
        const res = await updateDoc(doc(firestore, 'usuarios', model.id), data);
        !res ? message.success('Cambios guardados.') : message.error('Error al actualizar.');
      }
    } catch (error) {
      message.error('Error al guardar.');
      console.log(error)
    }
    setOpen(false);
  }

  const validar = async (item) => {
    const q1 = query(collection(firestore, "usuarios"), where("correo", "==", item.correo));
    const q2 = query(collection(firestore, "usuarios"), where("telefono", "==", item.telefono));
    const querySnapshot1 = await getDocs(q1);
    const querySnapshot2 = await getDocs(q2);
    let count = 0;
    querySnapshot1.forEach((doc) => {
      count++
    });
    querySnapshot2.forEach((doc) => {
      count++
    });
    if (count > 0) {
      message.warning('El usuario ya exite')
      return
    }
  }

  const reconocimiento = async (value, row) => {

    let data = {
      reconocimiento: model.reconocimiento !== undefined ? (model.reconocimiento === value ? !value : value) : value,
    }

    const res = await updateDoc(doc(firestore, 'usuarios', row.id), data);
    !res ? message.success('Actualizado correctamente') : message.error('Error al actualizar.');

  }

  const onSearch = (searchValue) => {
    setSearchInput(searchValue)
    if (searchValue !== '') {
      const filteredData = models.filter((item) => {
        return Object.values(item).join('').toLowerCase().includes(searchValue.toLowerCase());
      })
      setFilteredResults(filteredData)
    } else {
      setFilteredResults(models)
    }
  };

  const onDelete = async () => {
    console.log(models);

    models.map(async (item) => {
      if (item.rol === 'usuario')
        deleteDoc(doc(firestore, 'usuarios', item.id))
    })
  }

  const showDeleteConfirm = async (row) => {

    let estatus = row.estatus === undefined ? 1 : row.estatus;
    console.log(row, estatus)
    let txt = estatus === 1 ? 'Eliminar' : 'Restaurar';

    confirm({
      title: `¿Estás seguro de ${txt} el Usuario ${row.correo} ?`,
      icon: <ExclamationCircleOutlined/>,
      okText: `Si, ${txt}`,
      okType: estatus === 1 ? 'danger' : 'primary',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          await updateDoc(doc(firestore, "usuarios", row.id), {
            ...row,
            estatus: estatus === 0 ? 1 : 0,
          });
          message.success(estatus === 1 ? 'Usuario Eliminado' : 'Usuario restaurado');
        } catch (error) {
          console.log('Error al eliminar: ' + error);
          message.error('Error al eliminar');
        }
        setModel([]);
      },
      onCancel() {
      },
    });
  }

  const defaultText = prop => prop || <span style={{color: '#c7c3c3'}}>---</span>;

  const Columns = [
    {
      title: 'Correo Electrónico',
      dataIndex: 'correo',
      key: 'correo',
      render: defaultText,
    }, {
      title: 'Número de Télefono',
      dataIndex: 'telefono',
      key: 'telefono',
      render: defaultText,
    }, {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      render: (index, row) => (
        <>{row.nombre} {row.apellidos}</>
      ),
    },
    {
      title: 'Ciudad',
      dataIndex: 'ciudad',
      key: 'ciudad',
      render: defaultText,
    }, {
      title: 'Pais',
      dataIndex: 'pais',
      key: 'pais',
      render: defaultText,
    }, {
      title: 'Ocupación',
      dataIndex: 'ocupacion',
      key: 'ocupacion',
      render: defaultText,
    }, {
      title: 'Reconocimiento',
      dataIndex: 'reconocimiento',
      key: 'reconocimiento',
      render: (index, row) => {
        return row.reconocimiento !== undefined && row.reconocimiento === true ? <Switch
          checkedChildren="Reconocimiento"
          unCheckedChildren="No"
          defaultChecked
          size="default"
          onChange={(item) => {
            reconocimiento(item, row);
          }}
        /> : <Switch
          checkedChildren="Reconocimiento"
          unCheckedChildren="No"
          size="default"
          onChange={(item) => {
            reconocimiento(item, row);
          }}
        />
      },
    }, {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 110,
      render: (index, row) => (
        <div style={{justifyContent: 'space-around', display: 'flex'}}>
          {row.estatus !== undefined && row.estatus === 0 ? <Tooltip title="Restaurar">
            <Button
              type="default"
              shape="circle"
              onClick={() => {
                showDeleteConfirm(row);
                setModel(row)
              }}
              style={{backgroundColor: "#1890ff", color: "#ffffff"}}
              icon={<RollbackOutlined/>}/>
          </Tooltip> : <Tooltip title="Eliminar">
            <Button type="danger" shape="circle" onClick={() => {
              showDeleteConfirm(row);
              setModel(row)
            }} icon={<DeleteOutlined/>}/>
          </Tooltip>}
          <Tooltip title="Editar">
            <Button type="primary" shape="circle" onClick={() => {
              setModel(row);
              setOpen(true);
            }} icon={<EditOutlined/>}/>
          </Tooltip>
        </div>
      ),
      align: 'center'
    },
  ]

  let headersExcel = [
    {label: 'Nombre', key: 'nombre'},
    {label: 'Apellidos', key: 'apellidos'},
    {label: 'País', key: 'pais'},
    {label: 'Ciudad', key: 'ciudad'},
    {label: 'Empresa', key: 'empresa'},
    {label: 'Estatus', key: 'estatus'},
    {label: 'Teléfono', key: 'telefono'},
    {label: 'Fecha de rgistro', key: 'registro'},
    {label: 'Correo electróico', key: 'correo'},
    {label: 'Ocupación', key: 'ocupacion'},
    {label: 'Rol', key: 'rol'},
    {label: 'Pago', key: 'pago'},
  ];

  let dataExcel = models.map((item) => {
    item.estatus = (item.estatus) === 1 ? "Activo" : "Inactivo";
    return item;
  });

  return (
    <>
      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 12, offset: 0}}
          lg={{span: 12, offset: 0}}
          xxl={{span: 12, offset: 0}}
        >
          <Title level={4}>Registro de
            Usuarios {models.length >= 0 ? "(usuarios registrados " + (models.length - models.filter(model => model.estatus === 0).length) + ")" : ""}</Title>
        </Col>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 4, offset: 0}}
          lg={{span: 4, offset: 0}}
          xxl={{span: 4, offset: 0}}
        >

          <CSVLink
            filename={"usuarios.csv"}
            data={dataExcel}
            headers={headersExcel}
          >
            <Button size="large" block type="dashed" icon={<FileExcelOutlined/>}>
              Excel
            </Button>
          </CSVLink>


        </Col>
        <Col
          sm={{span: 24, offset: 0}}
          xs={{span: 24, offset: 0}}
          md={{span: 4, offset: 0}}
          lg={{span: 4, offset: 0}}
          xxl={{span: 4, offset: 0}}
        >
          <Button
            type='primary'
            size="large"
            block
            onClick={() => {
              setModel({});
              setOpen(true);
            }}
            icon={<PlusCircleOutlined/>}
          >Agregar
          </Button>
        </Col>
        <Col
          sm={{span: 24, offset: 0}}
          xs={{span: 24, offset: 0}}
          md={{span: 4, offset: 0}}
          lg={{span: 4, offset: 0}}
          xxl={{span: 4, offset: 0}}
        >
          <Button
            type='danger'
            size="large"
            block
            onClick={() => {
              onDelete()
            }}
            icon={<PlusCircleOutlined/>}
          >Eliminar usuarios
          </Button>
        </Col>
      </Row>
      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col style={{width: "100%"}}>
          <Search
            size="large"
            placeholder="Buscar"
            onSearch={onSearch}
            style={{width: "100%", float: 'right', marginBottom: 20, marginTop: 20}}
          />
        </Col>
      </Row>


      <Table
        style={{marginTop: 30}}
        dataSource={searchInput.length > 1 ? filteredResults : models.map((p) => ({...p, id: p.id}))}
        rowKey="id"
        columns={Columns}
        pagination={true}
        loading={loading}
        scroll={{x: 1000}}
      />

      <Dialog
        open={open}
        title={"Editar " + (model ? model.nombre : "")}
        onAccept={Save}
        onCancel={() => {
          setOpen(false);
          setModel({});
        }}
        onChange={(key, value) => {
          setModel({...model, [key]: value});
        }}
        model={model}
        type={"Editar"}
      />
    </>
  )
    ;
}

export default Users